import { Button, Col, Icons, Input, Row } from "@pankod/refine-antd";
import React, { useRef } from "react";

type CustomUploaderProps = {
  accept?: string;
  placeholder?: string;
  value?: File | null;
  onChange?: (file: File | null) => void;
  allowClear?: boolean;
  disabled?: boolean;
  hintText?: string;
};

export function CustomUploader({
  accept = ".csv",
  placeholder = "Faça o upload do arquivo",
  value,
  onChange,
  allowClear = true,
  disabled = false,
  hintText,
}: CustomUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const fileName = value?.name ?? "";

  const openDialog = () => {
    if (!disabled) fileInputRef.current?.click();
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;
    onChange?.(file);
    e.target.value = "";
  };

  const clearFile = () => {
    if (fileInputRef.current) fileInputRef.current.value = "";
    onChange?.(null);
  };

  return (
    <Input.Group>
      <Row gutter={8} style={{ justifyContent: "flex-end" }}>
        <Col
          flex="auto"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            position: "relative",
          }}
        >
          <Input
            placeholder={placeholder}
            value={fileName}
            readOnly
            onClick={openDialog}
            disabled={disabled}
            style={{ cursor: "pointer" }}
          />
          <span style={{ color: "#9E9E9E", top: 32, position: "absolute" }}>
            {hintText ?? `Formatos aceitos: ${accept}`}
          </span>
        </Col>

        <Col flex="none" style={{ display: "flex", gap: 8 }}>
          {allowClear && fileName && (
            <Button
              onClick={clearFile}
              disabled={disabled}
              icon={<Icons.CloseCircleOutlined />}
            />
          )}
          <Button
            type="primary"
            icon={<Icons.UploadOutlined />}
            onClick={openDialog}
            disabled={disabled}
          >
            Upload
          </Button>
        </Col>
      </Row>

      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </Input.Group>
  );
}
